<div class="side-content-wrap">
<nv-sidebar-list 
  [listData]="routeOptions" 
  [selectedKey]="selectedSidebarItem"
  (sidebarListItemSelect)="changeView($event)">
</nv-sidebar-list>
</div>